import { AsyncPipe } from "@angular/common";
import { Component, computed, effect, inject, input, output } from "@angular/core";
import { MonitoringCategory } from "@domain/product/monitoring/monitoring-product.service";
import { UtilityProductService } from "@domain/product/monitoring/utility-product.service";
import { UtilityConfiguration } from "@domain/project/configurations/monitoring/utility-configuration";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { FloorplanSidesheetExtent } from "@domain/project/floorplan/floorplan-sidesheet-extent";
import { FloorplanUtility } from "@domain/project/floorplan/monitoring/floorplan-utility";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";
import { FloorplanCustomPartNumbersComponent } from "@project/floorplanner/floorplan-custom-part-numbers/floorplan-custom-part-numbers.component";
import { FloorplanItemAttachmentsButtonComponent } from "@project/floorplanner/floorplan-item-attachments-button/floorplan-item-attachments-button.component";
import { FloorplanItemGroupComponent } from "@project/floorplanner/floorplan-item-group/floorplan-item-group.component";
import { MonitoringProductItem } from "@project/monitoring-product-item";
import {
  buildUtilityGroupedSourceItems,
  UtilityGroupedPartLabels,
} from "@project/monitoring/grouped-parts/monitoring-grouped-parts-source-item.factory";
import {
  getMonitoringConfigurationSummaryTitle,
  getUtilityGroupedPartLabels,
} from "@project/monitoring/grouped-parts/monitoring-grouped-parts.helper";
import { MonitoringGroupedPartSourceItem } from "@project/monitoring/grouped-parts/monitoring-grouped-parts.types";
import { Observable } from "rxjs";

@Component({
  selector: "app-utility-notes",
  imports: [
    AsyncPipe,
    FloorplanCustomPartNumbersComponent,
    FloorplanItemAttachmentsButtonComponent,
    FloorplanItemDetailsComponent,
    FloorplanItemGroupComponent,
  ],
  templateUrl: "./utility-notes.component.html",
  styleUrl: "./utility-notes.component.scss",
})
export class UtilityNotesComponent {
  readonly floorplanItem = input.required<FloorplanItem>();
  readonly extent = input.required<FloorplanSidesheetExtent>();
  readonly toggleExtendedButtonClicked = output<void>();
  protected readonly utility = computed(() => this.floorplanItem() as FloorplanUtility);
  protected readonly MonitoringCategory = MonitoringCategory;
  protected readonly SidesheetExtent = FloorplanSidesheetExtent;

  protected productItems!: MonitoringProductItem[];
  protected monitoringItems: MonitoringGroupedPartSourceItem[] = [];
  protected monitoringTitle = getMonitoringConfigurationSummaryTitle(MonitoringCategory.UTILITY);
  private readonly categoryLabels: UtilityGroupedPartLabels = getUtilityGroupedPartLabels();
  protected readonly defaultImageUrl = "./assets/floorplan-menu-icons/utility_menu.svg";
  private utilityProductService = inject(UtilityProductService);
  protected readonly imageUrl$ = computed<Observable<string>>(() =>
    this.utilityProductService.resolveImageUrl(this.utility().config),
  );

  constructor() {
    effect(() => {
      const config = this.utility().config;
      this.productItems = config.getOptions();
      this.monitoringItems = this.buildMonitoringItems(config);
    });
  }

  private buildMonitoringItems(config: UtilityConfiguration): MonitoringGroupedPartSourceItem[] {
    return buildUtilityGroupedSourceItems(
      {
        devices: config.devices,
      },
      this.categoryLabels,
    );
  }
}
